import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import {style} from '../../../components/pdf/fontstyles';
import {AutoText} from '../../../components/pdf/autoText'; 


const styles = StyleSheet.create({
     
          solidLine: {
           
            borderBottomWidth: 1,   // thickness of the line
            borderBottomColor: '#000', // color (black here)
            width: '100%',         // full width of page or container
          },
          
          table: {
            
            display: 'table',
            width: '100%',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#000',
          },
          row: {
            flexDirection: 'row',
            borderBottom: '1px solid #000',
          },
          cell: {
            padding: 5,
            borderRight: '1px solid #000',
            verticalAlign: 'middle',
          },
          headerCell: {
            fontWeight: 'bold',
            backgroundColor: '#f2f2f2',
          },
          // Column specific styles (adjust widths for each column)
          srNoCell: {
            width: '5%', // First column with smaller width
          },
          detailsCell: {
            width: '55%', // Second column with larger width
          },
          pageNoCell: {
            width: '40%', // Third column with medium width
          },

          bulletRow: {
            flexDirection: 'row',
            alignItems: 'flex-start',
            marginBottom: 6, // space between bullet points
          },
          bulletSymbol: {
            width: 10, // fixed width for bullet
            fontSize: 10,
            marginRight: 5, // gap between bullet and text
          },
          bulletText: {
            flex: 1,
            fontSize: 10,
            textAlign: 'justify',
            lineHeight: 1.5,
          },
          


        });


        
        
const Form6Part1 = ({ result }) => {

    const tableData = [
        ['1', 'Name of the Government servant', result.employeeName],
        ['2', `a) Father’s Name (and also husband’s name in the case of a female Government servant.)`,result.fatherName ],
        ['3', `Date of birth (by Christian era)`, result.dateOfBirth],
        ['4', 'Nationality, Religion', `Indian, ${result.religion}`],
        ['5', 'Permanent residential address showing village, town, district and Sate.', result.address],
        ['6', 
            `Present or last appointment including name of establishment.
               i)	Substantive
               ii)	Officiating, if any,`
               ,
            `${result.managementName} , ${result.institutionName} 
            Substantive  `
          ],
        ['7', 'Date of beginning of service', result.dateOfAppointment],
        ['8', 'Date of ending of service', result.dateOfRetirement],
        ['9',           
             `Total period of
              i)	Military service for which pension of gratuity was sectioned
              ii)	Amount and nature of any pension/ gratuity received for previous Civil service.`
                
          , `
          
          NIL
          
          NIL`],
        ['10', 
          'Amount and nature of any pension/ gratuity received for previous Civil service.',
          'NIL'
        ],
       
        ['11', 'Government under which service has been rendered in order of employment.', 
           `${result.calculation[0].pensionableService.years} Years ${result.calculation[0].pensionableService.months} Months ${result.calculation[0].pensionableService.days} Days`
        ],
        ['12', 
          'Class of pension applicable',
          result.typeOfRetirement
        ],
        ['13', 
            
         `The date on which action initiated to </Text>
          i)	Obtain the ‘ No demand certificate’ from the Executive Engineer concerned as provided in rule 119 of the Maharashtra Civil Services (Pension) Rules, 1982.
          ii)	Assess the service and pay qualifying for pension as provided in rule 122 of, the Maharashtra Civil Services (Pension) Rules 1982.
          iii)	Assess the Government dues other than dues relating to the allotment of Government accommodation as provided in rule 134 of the Maharashtra Civil Services (Pension) Rules 1982.`
              , 
          'NIL'
        ],

      ];
      
  
  return (
              <View size="A4" style={style.page}> 
                <Text style={[style.title, style.ArialBlack]}>FORM - 6</Text>
                <Text style={[style.subtitle]}>[See rules 120,122,123,(i) and (3) and 127(i)]</Text>
                <Text style={[style.subtitle, { fontSize: 10 }]}>
                Form for Assessing Pension and Gratuity
                </Text>
                <View style={[style.solidLine]} />
                <Text style={[style.subtitle]}>
                ( To be sent in duplicate if payment if desired in another Audit Circle)
                </Text>



                <Text style={[style.subtitle, style.ArialBold, { fontSize: 10 }, {marginBottom: 0}]}>PART – I</Text>


               {/* Table */}
                   <View style={[styles.table, { marginTop: 2 }]}>
                    
                     {/* Table Data */}
                     {tableData.map(([srNo, details, value], index) => (
                      <View style={styles.row} key={index}>
                        <Text style={[styles.cell, styles.srNoCell]}>{srNo}</Text>
                        <Text style={[styles.cell, styles.detailsCell]}>{details}</Text>
                        <AutoText style={[styles.cell, styles.pageNoCell]}>{value}</AutoText>
                      </View>
                    ))}
              </View>


        
              </View>

);
};

export default Form6Part1;